<template>
  <div class="module-card-list">
    <div v-for="m in modules" :key="m.title" class="module-card" v-show="setup || m.enabled">
      <div class="module-card__title">
        <span :class='{iconopacity: !m.enabled}' @click="clickTitle(m)">
          {{m.title}}
          <!-- <i class='iconfont icon-unchecked' v-show="setup && !m.enabled"></i>
          <i class='iconfont icon-checked' v-show="setup && m.enabled"></i> -->
          <input type="checkbox" v-show="setup" :checked='m.enabled'>
        </span>
        <span class='module-card__icon'  @click="clickSetup">
          <span v-show="setup">完成</span>
          <span v-show="!setup">···</span>
        </span>
      </div>
      <div class="weui-grids-nobarder">
        <a
          href="javascript:;"
          v-for="item in m.items"
          class="weui-grid-noborder"
          :class='{iconopacity: !item.enabled}'
          :key="item.title"
          @click="gotoView(item)"
          v-show="setup || item.enabled"
        >
          <span class='checkbox' v-show="setup">
            <i class='iconfont icon-checked' v-show="item.enabled"></i>
            <i class='iconfont icon-unchecked' v-show="!item.enabled"></i>
          </span>
          <div class="weui-grid__icon">
            <i :class="item.logo"></i>
            <!-- <img alt :src="item.logo" /> -->
          </div>
          <p class="weui-grid__label">{{item.title}}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modules: Array,
  },
  data() {
    return {
      setup: false,
    }
  },
  methods: {
    clickTitle(m) {
      if(this.setup) {
        m.enabled = !m.enabled
        this.$emit('enabledChange', m.id, m.enabled)
      }
    },
    gotoView(item) {
      if(this.setup) {
        item.enabled = !item.enabled
        this.$emit('enabledChange', item.id, item.enabled)
      }
      else if (!this.setup && item.path) {
        this.$router.push(item.path);
      }
    },
    clickSetup() {
      this.setup = !this.setup
      if(!this.setup) {
        this.$emit('updateSetup')
      }
    },
  }
};
</script>
                                 
<style scoped>
.module-card__title {
  font-size: 13px;
  font-weight: bold;
  padding: 8px 15px 7px;
  /* color: #000000; */
  color: var(--weui-FG-0);
  letter-spacing: 2px;
  display: flex;
  justify-content: space-between;
}
.weui-grids-nobarder {
  /* background: #fff; */
  background: var(--weui-BG-5);
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}
.weui-grid-noborder {
  padding: 10px 0;
  flex: 0 0 25%;
  position: relative;
}
.weui-grid-noborder .checkbox {
  position: absolute;
  top: 0;
  right: 10px;
  /* color: #333333; */
  color: var(--weui-FG-0);
}
.iconopacity{
  opacity: 0.2;
}
.weui-grid__label {
  font-size: 12px;
  /* color: #333333; */
  color: var(--weui-FG-0);
  letter-spacing: 1.6px;
}
.weui-grid__icon i {
  font-size: 26px;
  line-height: 26px;
  background: #fff;
  border-radius: 5px;
}
.green-font {
  color: #1ab584;
}
.blue-font {
  color: #338aca;
}
.red-font {
  color: #e04240;
}
.orange-font {
  color: #f7941d;
}
</style>
